import { Icon } from '@iconify/react'
import { Box, Button, Card, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useMemo } from 'react'
import { THorse } from '../../shared/types/horse.type'
import dayjs from 'dayjs'
import { useAuth } from '../../hooks/useAuth'
import utc from 'dayjs/plugin/utc'
import { useDispatch } from 'react-redux'
import { setEditHorseHrModal, setHorseHrExams, setHorseToEdit } from '../../store/reducers/modal.reducer'
import { TtrainingKeyParameterItem } from '../../shared/types/TrainingKeyParameterItem.type'
import { Ttraining } from '../../shared/types/training.type'

dayjs.extend(utc)
function HorseHr({ horse, examParams, isComparing, horseExams }: {
    horse?: THorse,
    examParams: TtrainingKeyParameterItem[],
    isComparing: boolean,
    horseExams: Ttraining[]

}) {
    const dispatch = useDispatch()


    useEffect(() => {

        dispatch(setHorseHrExams(horseExams))
    }, [horseExams])

    const getTootlTipText = useMemo(() => {
        let source = horse?.max_heart_rate_data?.source
        if (!source) return t('parameters:defaultValue')

        switch (source) {
            case 'default':
                return t('parameters:defaultValue')
            case 'user_defined':
                let date = dayjs.utc(horse?.max_heart_rate_data.start_date).format('DD/MM/YYYY')
                return t('parameters:valueEnteredOn', { date: String(date), interpolation: { escapeValue: false } })

            case 'post_processing_training':
                return t('parameters:automaticallyComputed')

            default:
                return t('parameters:defaultValue')

        }

    }, [horse?.max_heart_rate_data])

    const openEditModal = () => {
        if (horse) {
            dispatch(setEditHorseHrModal(true))
            dispatch(setHorseToEdit(horse))
            dispatch(setHorseHrExams(horseExams))
        }
    }

    return (
        <Card sx={{ p: 2 }}>
            <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'}>
                <Typography variant='h6'>
                    {t('parameters:maxHeartRate')}
                </Typography>
                <Tooltip arrow title={getTootlTipText} placement='left'>
                    <Icon icon={'fluent-mdl2:info'} width={22} height={22}></Icon>
                </Tooltip>
            </Box>

            <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'} mt={2}>
                <Typography variant='subtitle2'>{t('value')} : {horse?.max_heart_rate_data?.max_heart_rate ?? 0} {t('units:bpm')}</Typography>
                <Button disabled={isComparing} onClick={openEditModal}>{t('button:edit')}</Button>


            </Box>
        </Card>
    )
}

export default HorseHr